import React from 'react'
import { useTheme } from 'styled-components'

import { IconComponent } from '@application/Interfaces/Icons/types'
import { Theme } from '@application/Interfaces/Themes/ThemeType'

export const CalendarIcon: IconComponent = ({ className, colorCode = 'black', width = 16, height = 16 }) => {
    const theme = useTheme() as Theme
    const color = theme.color[colorCode]

    return (
        <svg
            className={className}
            width={width}
            height={height}
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0 3.5C0 2.67157 0.671573 2 1.5 2H14.5C15.3284 2 16 2.67157 16 3.5V14.5C16 15.3284 15.3284 16 14.5 16H1.5C0.671573 16 0 15.3284 0 14.5V3.5ZM1.5 3C1.22386 3 1 3.22386 1 3.5V14.5C1 14.7761 1.22386 15 1.5 15H14.5C14.7761 15 15 14.7761 15 14.5V3.5C15 3.22386 14.7761 3 14.5 3H1.5Z"
                fill={color}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0 6.5C0 6.22386 0.223858 6 0.5 6H15.5C15.7761 6 16 6.22386 16 6.5C16 6.77614 15.7761 7 15.5 7H0.5C0.223858 7 0 6.77614 0 6.5Z"
                fill={color}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M4.5 0C4.77614 0 5 0.223858 5 0.5V4C5 4.27614 4.77614 4.5 4.5 4.5C4.22386 4.5 4 4.27614 4 4V0.5C4 0.223858 4.22386 0 4.5 0Z"
                fill={color}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M11.5 0C11.7761 0 12 0.223858 12 0.5V4C12 4.27614 11.7761 4.5 11.5 4.5C11.2239 4.5 11 4.27614 11 4V0.5C11 0.223858 11.2239 0 11.5 0Z"
                fill={color}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M3 9.25C3 8.83579 3.33579 8.5 3.75 8.5C4.16421 8.5 4.5 8.83579 4.5 9.25C4.5 9.66421 4.16421 10 3.75 10C3.33579 10 3 9.66421 3 9.25Z"
                fill={color}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M3 12.75C3 12.3358 3.33579 12 3.75 12C4.16421 12 4.5 12.3358 4.5 12.75C4.5 13.1642 4.16421 13.5 3.75 13.5C3.33579 13.5 3 13.1642 3 12.75Z"
                fill={color}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M7.25 9.25C7.25 8.83579 7.58579 8.5 8 8.5C8.41421 8.5 8.75 8.83579 8.75 9.25C8.75 9.66421 8.41421 10 8 10C7.58579 10 7.25 9.66421 7.25 9.25Z"
                fill={color}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M7.25 12.75C7.25 12.3358 7.58579 12 8 12C8.41421 12 8.75 12.3358 8.75 12.75C8.75 13.1642 8.41421 13.5 8 13.5C7.58579 13.5 7.25 13.1642 7.25 12.75Z"
                fill={color}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M11.5 9.25C11.5 8.83579 11.8358 8.5 12.25 8.5C12.6642 8.5 13 8.83579 13 9.25C13 9.66421 12.6642 10 12.25 10C11.8358 10 11.5 9.66421 11.5 9.25Z"
                fill={color}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M11.5 12.75C11.5 12.3358 11.8358 12 12.25 12C12.6642 12 13 12.3358 13 12.75C13 13.1642 12.6642 13.5 12.25 13.5C11.8358 13.5 11.5 13.1642 11.5 12.75Z"
                fill={color}
            />
        </svg>
    )
}
